Ext.define('SA.view.sidebar.data.DataSearchResultsAttribute', {
    alias: 'widget.data-search-results-attribute',
    extend: 'Ext.Component',

    statics: {
        hasVisibleMenu() {
            return Ext.ComponentQuery.query('data-search-results-attribute').some(instance => instance.hasVisibleMenu());
        }
    },

    cls: 'sa-data-search-results-attribute',

    renderTpl: [
        '<button class="sa-data-search-results-attribute-body">',
            '<span class="sa-data-search-results-attribute-name">{name:htmlEncode} {badgesHtml}</span>',
            '<span class="sa-data-search-results-attribute-check-wrap" title="Added to project">',
                '<svg aria-hidden="true" class="sa-data-search-results-attribute-check">',
                    '<use href="#sa-icon-check-mark"></use>',
                '</svg>',
            '</span>',
        '</button>',
        '<button aria-label="attribute menu" class="sa-data-search-results-attribute-button">',
            '<div class="sa-data-search-results-attribute-button-dot"></div>',
            '<div class="sa-data-search-results-attribute-button-dot"></div>',
            '<div class="sa-data-search-results-attribute-button-dot"></div>',
        '</button>'
    ],

    initComponent() {
        this.callParent();

        this.setSelected(this.selected || false);
    },

    beforeRender() {
        var {attribute} = this;

        this.callParent();

        this.renderData = {
            ...this.renderData,
            name: SA.view.sidebar.data.DataSearchResults.getDisplayName(attribute),
            badgesHtml: SA.AttributeBadges.getHtml({attribute, includeDatasetAbbreviation: false})
        };
    },

    getAttribute() {
        return this.attribute.attribute;
    },

    hasVisibleMenu() {
        return this.lastMenu?.isVisible();
    },

    initEvents() {
        this.callParent();

        this.el.on('click', this.onBodyClick, this, {delegate: '.sa-data-search-results-attribute-body'});
        this.el.on('mouseout', this.onBodyMouseOut, this, {delegate: '.sa-data-search-results-attribute-body'});
        this.el.on('mouseover', this.onBodyMouseOver, this, {delegate: '.sa-data-search-results-attribute-body'});

        this.el.on('click', this.onButtonClick, this, {delegate: '.sa-data-search-results-attribute-button'});
    },

    onBodyClick() {
        this.useVariable();
    },

    onBodyMouseOut() {
        this.el.removeCls('sa-data-search-results-attribute-over');
    },

    onBodyMouseOver() {
        this.el.addCls('sa-data-search-results-attribute-over');
    },

    onButtonClick(ev, target) {
        var {el} = this,
            menu = this.lastMenu;

        if (menu && menu.wasRecentlyVisible()) {
            return;
        }

        el.addCls('sa-data-search-results-attribute-button-active');

        menu = this.lastMenu = Ext.widget({
            xtype: 'menu',
            getRefOwner: () => this,
            track: true,

            defaults: {
                attribute: this.getAttribute()
            },

            items: [
                {
                    text: 'Use this Data Variable',

                    handler: () => {
                        this.useVariable();
                    }
                }, {
                    xtype: 'menu-add-remove-favorite-attribute'
                }, {
                    xtype: 'menu-view-attribute-metadata'
                }
            ],

            listeners: {
                hide(menu) {
                    Ext.destroy(menu);

                    el.removeCls('sa-data-search-results-attribute-button-active');
                }
            },

            plugins: [{
                ptype: 'sa-arrow',
                target
            }]
        });

        menu.showBy(el, 'tr-br?', [0, 7]);
    },

    setSelected(selected) {
        this.ifCls(selected, 'sa-data-search-results-attribute-selected');
    },

    useVariable() {
        var {el} = this;

        if (el.hasCls('sa-data-search-results-attribute-selected-animation')) {
            el.removeCls('sa-data-search-results-attribute-selected-animation');

            el.getStyle('background-color');
        }

        el.addCls('sa-data-search-results-attribute-selected-animation');

        this.fireEvent('select', this.getAttribute());
    }
});
